/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import * as S from './styles'
import { TFInvoice } from '../../../../utils/models'
import keyboardDownIcon from '../../../../assets/icons/keyboardDownIcon.svg'

interface InvoiceItemProps {
  invoiceItem: TFInvoice
  checkIdList(invoiceIdparse: number | null): boolean
  handlePaymentButton(invoice: TFInvoice): void
  invoiceDescription(invoice: TFInvoice): string
  generatingColorStatus(inv: TFInvoice): string
  generatingTextStatus(inv: TFInvoice): string
  checkDueDate(dataInvoice: string): boolean
  checkDueStatus(invoiceInfo: TFInvoice): boolean
}

export const InvoiceItem = ({
  invoiceItem,
  checkIdList,
  handlePaymentButton,
  invoiceDescription,
  generatingColorStatus,
  generatingTextStatus,
  checkDueDate,checkDueStatus
}: InvoiceItemProps) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const isDisabled = !checkDueDate(invoiceItem.paymentDueDate) || !checkDueStatus(invoiceItem)
  function transformDate(d: string): string {
    const dSplit = d.split('-')

    return `${dSplit[2]}/${dSplit[1]}/${dSplit[0]}`

    return ''
  }

  return (
    <S.InvoiceItem
      isDisabledButton={isDisabled}
      isOpen={isOpen}
      key={invoiceItem.invoice_id}
    >
      <div
        onClick={() => {
          handlePaymentButton(invoiceItem)
        }}
        className="grid_container_row invoice_header"
      >
        <div className="grid_container_center">
          <input
            className="grid_check invoice_item_check"
            type="checkbox"
            id="checkBox"
            disabled={isDisabled}
            checked={checkIdList(invoiceItem.invoice_id)}
          />
        </div>
        <div className="grid_container_center invoice_pointer">
          <p>{invoiceItem.id || '-'}</p>
        </div>
        <div className="grid_container_center invoice_pointer">
          <p>{invoiceItem.paymentDueDate ? transformDate(invoiceItem.paymentDueDate) : '-'}</p>
        </div>
        <div className="grid_container_center ">
          <div
            style={{
              display: 'grid',
            }}
          >
            <p className="text_overflow">
              {invoiceDescription(invoiceItem) || '-'}
            </p>
          </div>
        </div>
        <div className="grid_container_center grid_container_end">
          <p className="invoice_value">
            {`${invoiceItem.totalPaymentDue?.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}`}
          </p>
        </div>
        <div className="grid_container_center">
          <div className="invoice_status_container">
            <S.InvoiceItemStatus color={generatingColorStatus(invoiceItem)} />
            <p>{generatingTextStatus(invoiceItem) || '-'}</p>
          </div>
        </div>
        <div
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setIsOpen((opened) => !opened)
          }}
          className="grid_container_center invoice_item_dropdown_button"
        >
          <img
            className="arrow_icon"
            alt="keyboardDownIcon"
            src={keyboardDownIcon}
          />
        </div>
      </div>
      <div className="invoice_custas_container">
        {invoiceItem.extras?.custa?.map((custa, index) => (
          <div className="invoice_max_width" key={index}>
            {custa.itemGuia.length ? (
              custa.itemGuia.map((itemGuia, indexItem) => {
                return (
                  <div
                    key={indexItem}
                    className="invoice_row_between invoice_max_width"
                  >
                    <p className="invoices_custas_label">
                      {itemGuia.descricao}
                    </p>
                    <p className="invoices_custas_title">
                      {`R$ ${itemGuia.valor.toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                      })}`}
                    </p>
                  </div>
                )
              })
            ) : (
              <div className="invoice_row_between invoice_max_width">
                <p className="invoices_custas_label">{custa.descricao}</p>
                <p className="invoices_custas_title">
                  {custa.valorCusta
                    ? `R$ ${(custa.valorCusta || 0).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                      })}`
                    : null}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </S.InvoiceItem>
  )
}
